/* eslint-disable */
import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';
import { getSessionStorage, setSessionStorage, isEDMode } from '../patterns/helper.js';

const body = document.querySelector('body');
var instantiatedByEl = false;

const modalHooks = {
    hasScrolledToBottom: false,
    addModalError: function (target) {},
    removeModalError: function (target) {},
    beforeOpen: function (target) {
        PL_utils.addClass('modal-open', body);
    },
    afterOpen: function (target) {},
    onContinue: function (e, target) {},
    onCancel: function () {
        return false;
    },
    beforeClose: function () {
        // Set session storage before modal closes
        setSessionStorage('labelModal', true);
        
        const isActive = document.querySelector('.modal-label.modal--active');
        document.querySelectorAll('.modal').forEach((item) => {
            if (!item.getAttribute('hidden')) {
                item.setAttribute('hidden', '');
                item.setAttribute('aria-hidden', true);
            }
        });
        if (!isEDMode && isActive) {
            window.eventsManager.emit('hideModal', { type: 'label', params: '' });
        }
        return false;
    },
    afterClose: function () {
        PL_utils.removeClass('modal-open', body);
        if (instantiatedByEl) {
            instantiatedByEl.focus();
            instantiatedByEl = false;
        }
    },
    setSize: function () {
        return false;
    },
    onScreenshot: function () {
        return false;
    },
    onInit: function (target) {}
};

const modalOpts = {
    enableBackdropClose: true
};

const applyAccessibility = (ModalEle) => {
    const el_label = ModalEle.querySelector('[data-label]');
    if (el_label !== null && !isEDMode) {
        ModalEle.setAttribute('aria-label', el_label.innerHTML);
        ModalEle.setAttribute('role', 'dialog');
        ModalEle.setAttribute('aria-modal', 'true');
        ModalEle.removeAttribute('hidden');
        ModalEle.removeAttribute('aria-hidden');
        ModalEle.setAttribute('tabIndex', '0');
    }
};

const labelModalEle = document.querySelector('.modal-label');
const labelModal = modal.initModal(labelModalEle, modalHooks, modalOpts);

// Add event listener for btn-label button
const btnLabel = document.querySelector('.btn-label');
if (btnLabel) {
    btnLabel.addEventListener('click', (e) => {
        labelModal.hideModal();
    });
}

const publicInterface = {
    init: function () {
        // Check if modal should be shown based on session storage and global state
        const hasShownModal = getSessionStorage('labelModal');
        // Changed condition to explicitly check for true since null is a valid state
        const shouldShowModal = hasShownModal !== true && !isEDMode;
        

        if (shouldShowModal) {
            // Function to check if cookie consent is dismissed
            const isCookieConsentDismissed = () => {
                // Check for both the cookie and the OneTrust consent element
                const hasCookie = document.cookie.includes("OptanonAlertBoxClosed");
                const consentBanner = document.querySelector('#onetrust-banner-sdk');
                const isConsentHidden = consentBanner ? window.getComputedStyle(consentBanner).display === 'none' : false;
                return hasCookie || isConsentHidden;
            };

            // Function to show the label modal
            const showLabelModal = () => {
                instantiatedByEl = document.activeElement;
                applyAccessibility(labelModalEle);
                if (labelModalEle) {
                    labelModal.showModal();
                }
            };

            // Check if cookie consent is already dismissed
            if (isCookieConsentDismissed()) {
                showLabelModal();
            } else {
                // Set up a mutation observer to watch for cookie changes
                const observer = new MutationObserver((mutations) => {
                    if (isCookieConsentDismissed()) {
                        showLabelModal();
                        observer.disconnect();
                    }
                });

                // Start observing the document body for various changes
                observer.observe(document.body, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        }
    }
};


export default publicInterface;